/**
 * Contact validation utilities using google-libphonenumber
 */
import _ from 'lodash'
import {z} from 'zod'

import {PhoneNumber} from '../../../types'
import {phoneNumberToString, isPhoneNumberValid} from '../../../utils/phoneNumberUtils'

import {ContactErrorCodes} from './errorCodes'

type ContactType = 'siteContact' | 'orderPlacer'

export const validatePhoneNumber = (
  ctx: z.RefinementCtx,
  contactType: ContactType,
  phoneNumber?: PhoneNumber
) => {
  const isValid =
    phoneNumber &&
    _.isString(phoneNumber.number) &&
    phoneNumber.number.length > 0 &&
    _.isString(phoneNumber.dialingCode) &&
    phoneNumber.dialingCode.length > 0 &&
    isPhoneNumberValid(phoneNumberToString(phoneNumber) || '', phoneNumber.country)

  if (!isValid) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [contactType, 'phoneNumber'],
      message: ContactErrorCodes.contactInvalidPhoneNumber,
      params: {
        type: ContactErrorCodes.contactInvalidPhoneNumber
      }
    })
  }
}

export const validateName = (ctx: z.RefinementCtx, contactType: ContactType, name?: string) => {
  if (!name) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [contactType, 'name'],
      message: ContactErrorCodes.contactNameRequired,
      params: {
        type: ContactErrorCodes.contactNameRequired
      }
    })
  }
}
